import { post } from "@services/apiService.js";

export default {
  submitReport(data) {
    return post(`/v4/report-manager/v1/reports`, data)
    .then(response => {
      return response.data || {};
    }).catch(error => {
      return error.response
    });
  },
  addReportLogs(data) {
    const req = post(`/v4/report-manager/v1/reports/${data.id}/logs`, data)
    req.then(response => {
      return response.data || {};
    }).catch(error => {
      return error.response
    });
  },
}